import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PublicLayout } from "./layouts/PublicLayout";
import { TwoColumnLayout } from "./layouts/TwoColumnLayout";
import { AddMaster } from "./pages/AddMaster";
import { BuildingsPage } from "./pages/Buildings";
import { BuildingEditPage } from "./pages/Buildings/Edit";
import { NewBuildingPage } from "./pages/Buildings/New";
import { BuildingWorkScorePage } from "./pages/building-work-score/BuildingWorkScorePage";
import { HighPrioritiesPage } from "./pages/HighPriorities";
import { NewHighPriorityPage } from "./pages/HighPriorities/New";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { MatchingsPage } from "./pages/Matchings";
import { ModifyWorkShift } from "./pages/Matchings/ModifyWorkShift";
import { NewMatchingPage } from "./pages/Matchings/New";
import { PreviewPage } from "./pages/Matchings/Preview";
import { MatchingShowPage } from "./pages/Matchings/Show";
import { NGsPage } from "./pages/NGs";
import { NewNGPage } from "./pages/NGs/New";
import { StaffsPage } from "./pages/Staffs";
import { StaffEditPage } from "./pages/Staffs/Edit";
import { NewStaffPage } from "./pages/Staffs/New";
import { StaffWorkScorePage } from "./pages/staff-work-score/StaffWorkScorePage";
import { UsersPage } from "./pages/Users";
import { ChangePasswordUserPage } from "./pages/Users/ChangePassword";
import { EditUserPage } from "./pages/Users/Edit";
import { NewUserPage } from "./pages/Users/New";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="/" element={<TwoColumnLayout />}>
          <Route index element={<Home />} />
          <Route path="/matchings" element={<MatchingsPage />} />
          <Route path="/matchings/new" element={<NewMatchingPage />} />
          <Route path="/matchings/:id/modify" element={<ModifyWorkShift />} />
          <Route path="/matchings/:sessionId/preview" element={<PreviewPage />} />
          <Route path="/matching-ngs" element={<NGsPage />} />
          <Route path="/matching-ngs/new" element={<NewNGPage />} />
          <Route path="/high-priorities" element={<HighPrioritiesPage />} />
          <Route path="/high-priorities/new" element={<NewHighPriorityPage />} />
          <Route path="/staffs" element={<StaffsPage />} />
          <Route path="/staffs/:id/edit" element={<StaffEditPage />} />
          <Route path="/staffs/:id/score" element={<StaffWorkScorePage />} />
          <Route path="/staffs/new" element={<NewStaffPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/new" element={<NewUserPage />} />
          <Route path="/users/:id/edit" element={<EditUserPage />} />
          <Route path="/users/:id/change-password" element={<ChangePasswordUserPage />} />
          <Route path="/buildings" element={<BuildingsPage />} />
          <Route path="/buildings/new" element={<NewBuildingPage />} />
          <Route path="/buildings/:id/edit" element={<BuildingEditPage />} />
          <Route path="/buildings/:id/score" element={<BuildingWorkScorePage />} />
          <Route path="/add-master" element={<AddMaster />} />
          <Route path="/matchings/:id" element={<MatchingShowPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
